import React, { Component } from 'react';

export default class DetalhesCentroCusto extends Component {

    render() {
        if (!this.props.centroCusto.exibirDetalhe) {
            return ''
        }
        return (
            <div className="card-body cinza-zebrado table-responsive-sm">
                <table className="table table-sm table-bordered">
                    <tbody>
                        <tr style={{backgroundColor: '#ffffff66'}}>
                            <td className='text-center'><strong>Ocorrência</strong></td>
                        </tr>
                        <tr>
                            <td>{this.props.centroCusto.ocorrencia}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}
